import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import { postImport } from "common/lib/importClient";

const api = new APIClient();

export const getContracts = (params: any) => api.get(url.GET_CONTRACTS, params);
export const getContract = (id: any, params: any) => {
  const populate = [
    "contractor",
    "subContractedTo",
    "contractRating",
    "contractType",
    "agency",
    "agency.mainLogoLight",
    "agency.mainLogo",
    "createdby",
    "createdby.agency",
    "updatedby",
    "updatedby.agency",
    "location",
    "lta",
  ];
  if (!params?.populate) params.populate = populate;
  return api.get(url.GET_CONTRACT + "/" + id, params);
};
export const addContract = (data: any) => api.create(url.ADD_CONTRACT, data);
export const importContract = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  if (options?.timeoutMs) {
    timeoutId = setTimeout(() => controller.abort(), options.timeoutMs);
  }

  return fetch(process.env.REACT_APP_API_URL + url.IMPORT_CONTRACT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const metadata = response.headers.get("X-Metadata");
      let parsedMetadata = null;
      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (e) {
          parsedMetadata = metadata;
        }
      }

      const blob = await response.blob();
      return { blob, metadata: parsedMetadata };
    })
    .finally(() => {
      if (timeoutId !== null) clearTimeout(timeoutId);
    });
};
export const exportContractsToCSV = (params: any) =>
  api.get(url.EXPORT_CONTRACTS_TO_CSV, params, {
    responseType: "blob",
  });
export const exportAgencyContractsToCSV = (params: any) =>
  api.get(url.EXPORT_AGENCY_CONTRACTS_TO_CSV, params, {
    responseType: "blob",
  });
export const updateContract = (id: any, data: any) =>
  api.put(url.UPDATE_CONTRACT + "/" + id, data);
export const deleteContract = (id: any) =>
  api.delete(url.DELETE_CONTRACT + "/" + id);
export const getContractDistributionByType = (params: any) =>
  api.get(url.GET_CONTRACT_DISTRIBUTION_BY_TYPE, params);
export const getContractDistributionByAgency = (params: any) =>
  api.get(url.GET_CONTRACT_DISTRIBUTION_BY_AGENCY, params);
export const getContractTotals = (params: any) =>
  api.get(url.GET_CONTRACT_TOTALS, params);
export const getContractDistributionByRegion = (params: any) =>
  api.get(url.GET_CONTRACT_DISTRIBUTION_BY_REGION, params);
export const getContractDistributionByRegionAndType = (params: any) =>
  api.get(url.GET_CONTRACT_DISTRIBUTION_BY_REGION_TYPE, params);
export const getAgencyContracts = (params: any) =>
  api.get(url.GET_AGENCY_CONTRACTS, params);
export const addAgencyContract = (data: any) =>
  api.create(url.ADD_AGENCY_CONTRACT, data);
export const deleteAgencyContract = (id: any) =>
  api.delete(url.DELETE_AGENCY_CONTRACT + "/" + id);
export const getAgencyActiveContractValue = (params: any) =>
  api.get(url.GET_AGENCY_ACTIVE_CONTRACT_VALUE, params);

export const getContractTypes = (params: any) =>
  api.get(url.GET_CONTRACT_TYPES, params);
export const getContractType = (id: any, params: any) =>
  api.get(url.GET_CONTRACT_TYPE + "/" + id, params);
export const addContractType = (data: any) =>
  api.create(url.ADD_CONTRACT_TYPE, data);
export const updateContractType = (id: any, data: any) =>
  api.put(url.UPDATE_CONTRACT_TYPE + "/" + id, data);
export const deleteContractType = (id: any) =>
  api.delete(url.DELETE_CONTRACT_TYPE + "/" + id);
export const exportContractTypesToCSV = (params: any) =>
  api.get(url.EXPORT_CONTRACT_TYPES_TO_CSV, params, { responseType: "blob" });
export const importContractType = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_CONTRACT_TYPE, data, accessToken, options);

export const getContractRatings = (params: any) =>
  api.get(url.GET_CONTRACT_RATINGS, params);
export const getContractRating = (id: any, params: any) =>
  api.get(url.GET_CONTRACT_RATING + "/" + id, params);
export const addContractRating = (data: any) =>
  api.create(url.ADD_CONTRACT_RATING, data);
export const updateContractRating = (id: any, data: any) =>
  api.put(url.UPDATE_CONTRACT_RATING + "/" + id, data);
export const deleteContractRating = (id: any) =>
  api.delete(url.DELETE_CONTRACT_RATING + "/" + id);
export const exportContractRatingsToCSV = (params: any) =>
  api.get(url.EXPORT_CONTRACT_RATINGS_TO_CSV, params, { responseType: "blob" });
export const importContractRating = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_CONTRACT_RATING, data, accessToken, options);
